
// noinspection JSAnnotator

export default {
	global: {
		faqAll: {
			name: 'faq-all',
			url: 'https://support.nexon.net/hc/en-us/categories/200262625-Billing-Services'
		},
	},
	th: {
		faqAll: {
			name: 'faq-all',
			url: 'https://th.nexon.com/forum/th/forum/283/board/664'
		},
	},
	tw: {
		faqAll: {
			name: 'faq-all',
			url: 'https://tw.nexon.com/forum/zh/forum/264/board/630/'
		},
	},
	sea: {
		faqAll: {
			name: 'faq-all',
			url: 'https://support.nexon.net/hc/en-us/categories/200262625-Billing-Services'
		},
	},
};




// WEBPACK FOOTER //
// ./src/config/add-balance-faq-all.js